/**
 * Memoria delle posizioni di scroll per chiave di history (location.key).
 * Modulo puro: nessun DOM, nessun React. Il tetto FIFO evita che una sessione
 * lunga accumuli chiavi senza limite; 50 posizioni coprono qualunque cammino
 * di navigazione reale.
 */
const TETTO = 50;
const posizioni = new Map();

export const saveScroll = (key, y) => {
  if (posizioni.has(key)) posizioni.delete(key); // reinserisce in coda
  posizioni.set(key, y);
  while (posizioni.size > TETTO) {
    const piuVecchia = posizioni.keys().next().value;
    posizioni.delete(piuVecchia);
  }
};

export const readScroll = (key) => posizioni.get(key);

export const hasScroll = (key) => posizioni.has(key);

export const resetScroll = () => posizioni.clear();
